import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';
import { INVOICES_ROUTES, MATERIALS_ROUTES, PROJECTS_ROUTES, QUOTATION_CHAPTERS_ROUTES, QUOTATION_MATERIALS_ROUTES, QUOTATION_SERVICES_ROUTES, QUOTATION_VERSIONS_ROUTES, QUOTATIONS_ROUTES, UNITS_TYPES_ROUTES, STEPS_ROUTES, FILES_ROUTES, PROJECTS_FILES_ROUTES, PLANNINGS_ROUTES, STEP_CATEGORIES_ROUTES, TRANSACTIONS_ROUTES, PROJECT_MATERIALS_ROUTES, PROJECT_PAYMENTS_ROUTE, PROJECT_SUBJECTS_ROUTE, ACCOUNT_ROUTES, NOTIFICATIONS_ROUTES, PROJECTS_ROOMS_ROUTE, QUOTATION_MATERIAL_VALIDATIONS_ROUTE } from '@providers/routes-config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var RequestV2Service = /** @class */ (function () {
    function RequestV2Service(http) {
        this.http = http;
        this.url = environment.api_url;
    }
    RequestV2Service.prototype.getAccount = function () {
        var END_POINT = ACCOUNT_ROUTES.GET.account;
        return this.http.get(this.url + END_POINT).toPromise();
    };
    RequestV2Service.prototype.getProjects = function (userId, full, includeTest) {
        if (full === void 0) { full = false; }
        if (includeTest === void 0) { includeTest = false; }
        var END_POINT = PROJECTS_ROUTES.GET.projects;
        var params = new HttpParams();
        if (userId) {
            params = params.append('uid', userId.toString());
        }
        if (full) {
            params = params.append('full', '1');
        }
        if (includeTest) {
            params = params.append('include_test', 'true');
        }
        return this.http.get(this.url + END_POINT, { params: params })
            .toPromise();
    };
    // Get specific project
    RequestV2Service.prototype.getProject = function (projectId, full) {
        if (typeof projectId !== 'undefined') {
            var END_POINT = PROJECTS_ROUTES.GET.project.replace(':id', projectId);
            var params = new HttpParams();
            if (full) {
                params = params.append('full', 'true');
            }
            return this.http.get(this.url + END_POINT, { params: params }).toPromise();
        }
        throw new Error('Couldn\'t get project: id undefined');
    };
    // Get quotations from a project
    RequestV2Service.prototype.getQuotations = function (idProject) {
        if (typeof idProject !== 'undefined') {
            var params = new HttpParams();
            params = params.append('pid', idProject);
            var END_POINT = QUOTATIONS_ROUTES.GET.quotations;
            return this.http.get(this.url + END_POINT, { params: params }).toPromise();
        }
        throw new Error('Couldn\'t get specific quotation of project');
    };
    // Get specific quotation of project
    RequestV2Service.prototype.getQuotation = function (idQuotation) {
        if (typeof idQuotation !== 'undefined') {
            var END_POINT = QUOTATIONS_ROUTES.GET.quotation.replace(':qid', idQuotation);
            return this.http.get(this.url + END_POINT).toPromise();
        }
        throw new Error('Couldn\'t get specific quotation of project');
    };
    // Get versions
    RequestV2Service.prototype.getVersions = function (idQuotation, _a) {
        var limit = _a.limit, sort = _a.sort, full = _a.full;
        if (typeof idQuotation !== 'undefined') {
            var params = new HttpParams();
            params = params.append('qids', idQuotation.toString());
            if (limit) {
                params = params.append('limit', limit.toString());
            }
            if (sort) {
                params = params.append("sort[" + sort.key + "]", sort.value.toString());
            }
            if (full) {
                params = params.append('full', '1');
            }
            var END_POINT = QUOTATION_VERSIONS_ROUTES.GET.quotation_versions;
            return this.http.get(this.url + END_POINT, { params: params }).toPromise();
        }
        throw new Error('Id quotation or id version is undefined');
    };
    RequestV2Service.prototype.getQuotationVersionFinancial = function (idVersion) {
        if (typeof idVersion !== 'undefined') {
            var END_POINT = QUOTATION_VERSIONS_ROUTES.GET.quotation_financial
                .replace(':vid', idVersion);
            return this.http.get(this.url + END_POINT).toPromise();
        }
        throw new Error('Id version is missing');
    };
    // Get version
    RequestV2Service.prototype.getVersion = function (idVersion) {
        if (idVersion) {
            var END_POINT = QUOTATION_VERSIONS_ROUTES.GET.quotation_version
                .replace(':vid', idVersion);
            return this.http.get(this.url + END_POINT).toPromise();
        }
        throw new Error('Id quotation or id version is undefined');
    };
    // Get chapters
    RequestV2Service.prototype.getChapters = function (idVersion, limit) {
        if (idVersion) {
            var END_POINT = QUOTATION_CHAPTERS_ROUTES.GET.quotation_chapters;
            var params = new HttpParams();
            params = params.append('vid', idVersion.toString());
            if (limit) {
                params = params.append('limit', limit.toString());
            }
            return this.http.get(this.url + END_POINT, { params: params }).toPromise();
        }
    };
    // Get services
    RequestV2Service.prototype.getServices = function (idChapter, limit) {
        if (idChapter) {
            var END_POINT = QUOTATION_SERVICES_ROUTES.GET.quotation_services;
            var params = new HttpParams();
            params = params.append('cid', idChapter.toString());
            if (limit) {
                params = params.append('limit', limit.toString());
            }
            return this.http.get(this.url + END_POINT, { params: params }).toPromise();
        }
    };
    // Get quotation materials
    RequestV2Service.prototype.getQuotationMaterials = function (idService, idProject, full, limit, showOption) {
        var END_POINT = QUOTATION_MATERIALS_ROUTES.GET.quotation_materials;
        var params = new HttpParams();
        if (idService) {
            params = params.append('sid', idService.toString());
        }
        if (idProject) {
            params = params.append('pid', idProject.toString());
        }
        if (full) {
            params = params.append('full', 'true');
        }
        if (limit) {
            params = params.append('limit', 'all');
        }
        if (showOption) {
            params = params.append('show_option', showOption);
        }
        return this.http.get(this.url + END_POINT, { params: params }).toPromise();
    };
    RequestV2Service.prototype.getMaterials = function (idProject, page, productCategory, idsVersion) {
        var params = new HttpParams();
        if (idProject) {
            params = params.append('pid', idProject);
        }
        if (page) {
            params = params.append('page', page);
        }
        if (productCategory) {
            params = params.append('ids_material_product_categories', productCategory.toString());
        }
        if (idsVersion) {
            params = params.append('ids_material_versions', idsVersion);
        }
        var END_POINT = MATERIALS_ROUTES.GET.materials;
        return this.http.get(this.url + END_POINT, { params: params }).toPromise();
    };
    // Get Top Materials filtered by categorie
    RequestV2Service.prototype.getTopAlternativeMaterial = function (idCategory, allLevel) {
        if (allLevel === void 0) { allLevel = false; }
        if (!idCategory) {
            throw new Error('Id category is undefined');
        }
        var END_POINT = MATERIALS_ROUTES.GET.top;
        var params = new HttpParams();
        params = params.append('category', idCategory);
        if (allLevel) {
            params = params.append('use_main_category', 'true');
        }
        return this.http.get(this.url + END_POINT, { params: params }).toPromise();
    };
    RequestV2Service.prototype.getUnitTypes = function () {
        var END_POINT = UNITS_TYPES_ROUTES.GET.unit_types;
        var params = new HttpParams();
        params = params.append('limit', 'all');
        return this.http.get(this.url + END_POINT, { params: params }).toPromise();
    };
    /**
     * Get invoices
     */
    RequestV2Service.prototype.getInvoices = function (idProject, full) {
        if (full === void 0) { full = false; }
        var END_POINT = INVOICES_ROUTES.GET.invoices;
        var params = new HttpParams();
        if (idProject) {
            params = params.append('pid', idProject.toString());
        }
        if (full) {
            params = params.append('full', '1');
        }
        return this.http.get(this.url + END_POINT, { params: params }).toPromise();
    };
    /**
     * Download quotation version
     * @param idVersion
     * @param mode
     * @param format
     * @param simplified
     */
    RequestV2Service.prototype.downloadQuotationVersion = function (idVersion, mode, format, simplified) {
        if (format === void 0) { format = 'pdf'; }
        if (simplified === void 0) { simplified = false; }
        if (idVersion) {
            var END_POINT = QUOTATION_VERSIONS_ROUTES.GET.download_version
                .replace(':vid', idVersion);
            var params = new HttpParams();
            params = params.append('version', mode);
            params = params.append('format', format);
            params = params.append('simplified', simplified.toString());
            return this.http
                .get(this.url + END_POINT, { params: params, responseType: 'blob', observe: 'response' })
                .toPromise();
        }
    };
    RequestV2Service.prototype.getProjectSteps = function (limit) {
        var END_POINT = STEPS_ROUTES.GET.steps;
        var params = new HttpParams();
        if (limit) {
            params = params.append('limit', 'all');
        }
        return this.http.get(this.url + END_POINT, { params: params }).toPromise();
    };
    // Download file
    RequestV2Service.prototype.downloadFile = function (idFile) {
        var END_POINT = FILES_ROUTES.GET.file
            .replace(':fid', idFile);
        return this.http.get(this.url + END_POINT, { responseType: 'blob', observe: 'response' }).toPromise();
    };
    // get project files
    RequestV2Service.prototype.getProjectFiles = function (idProject, full) {
        if (full === void 0) { full = false; }
        var END_POINT = PROJECTS_FILES_ROUTES.GET.project_files;
        var params = new HttpParams();
        if (idProject) {
            params = params.append('pid', idProject.toString());
        }
        if (full) {
            params = params.append('full', '1');
        }
        return this.http.get(this.url + END_POINT, { params: params }).toPromise();
    };
    /**
     * PLANNINGS
     */
    // Get a list of plannings. Either related to severals Projets
    // or to have only templates PLannings
    RequestV2Service.prototype.getPlannings = function (idProject, template, full) {
        var END_POINT = PLANNINGS_ROUTES.GET.plannings;
        var params = new HttpParams();
        if (idProject) {
            params = params.append('pid', idProject);
        }
        if (template) {
            params = params.append('template', 'true');
        }
        if (full) {
            params = params.append('full', 'true');
        }
        return this.http.get(this.url + END_POINT, { params: params }).toPromise();
    };
    // Project step categories
    RequestV2Service.prototype.getStepCategories = function () {
        var END_POINT = STEP_CATEGORIES_ROUTES.GET.step_categories;
        return this.http.get(this.url + END_POINT).toPromise();
    };
    /**
     * Get transactions
     */
    RequestV2Service.prototype.getTransactions = function (idProject, full) {
        var END_POINT = TRANSACTIONS_ROUTES.GET.transactions;
        var params = new HttpParams();
        if (idProject) {
            params = params.append('pid', idProject.toString());
        }
        if (full) {
            params = params.append('full', '1');
        }
        return this.http.get(this.url + END_POINT, { params: params }).toPromise();
    };
    /**
     * Get payment requests
     */
    RequestV2Service.prototype.getProjectMaterials = function (idProject, full, limit) {
        var END_POINT = PROJECT_MATERIALS_ROUTES.GET.project_materials;
        var params = new HttpParams();
        if (idProject) {
            params = params.append('pid', idProject.toString());
        }
        if (full) {
            params = params.append('full', '1');
        }
        if (limit) {
            params = params.append('limit', limit);
        }
        return this.http.get(this.url + END_POINT, { params: params }).toPromise();
    };
    /**
     * Get project payments
     */
    RequestV2Service.prototype.getProjectPayments = function (idProject) {
        var END_POINT = PROJECT_PAYMENTS_ROUTE.GET.project_payments;
        var params = new HttpParams();
        if (idProject) {
            params = params.append('pid', idProject.toString());
        }
        return this.http.get(this.url + END_POINT, { params: params }).toPromise();
    };
    // Get List of projects with related users
    RequestV2Service.prototype.getProjectSubjects = function (idProject, full) {
        var END_POINT = PROJECT_SUBJECTS_ROUTE.GET.listsubjects;
        var params = new HttpParams();
        if (idProject) {
            params = params.append('pid', idProject.toString());
        }
        if (full) {
            params = params.append('full', full);
        }
        return this.http.get(this.url + END_POINT, { params: params }).toPromise();
    };
    // Create a subject
    RequestV2Service.prototype.addProjectSubject = function (subject) {
        var END_POINT = PROJECT_SUBJECTS_ROUTE.POST.subject;
        return this.http.post(this.url + END_POINT, subject).toPromise();
    };
    // Send notification
    RequestV2Service.prototype.getNotifications = function (projectId) {
        var END_POINT = NOTIFICATIONS_ROUTES.GET.notifications;
        var params = new HttpParams();
        params = params.append('pid', projectId);
        return this.http.get(this.url + END_POINT, { params: params }).toPromise();
    };
    // Project Rooms
    RequestV2Service.prototype.getProjectRooms = function (project) {
        var END_POINT = PROJECTS_ROOMS_ROUTE.GET.project_rooms;
        if (!project) {
            return null;
        }
        var params = new HttpParams();
        params = params.append('pid', project.id.toString());
        return this.http.get(this.url + END_POINT, { params: params }).toPromise();
    };
    RequestV2Service.prototype.getListQuotationMaterialValidation = function (idProject, limit) {
        var END_POINT = QUOTATION_MATERIAL_VALIDATIONS_ROUTE.GET.quotation_material_validation;
        var params = new HttpParams();
        if (idProject) {
            params = params.append('pid', idProject.toString());
        }
        if (limit) {
            params = params.append('limit', 'all');
        }
        return this.http.get(this.url + END_POINT, { params: params }).toPromise();
    };
    RequestV2Service.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RequestV2Service_Factory() { return new RequestV2Service(i0.ɵɵinject(i1.HttpClient)); }, token: RequestV2Service, providedIn: "root" });
    return RequestV2Service;
}());
export { RequestV2Service };
